export const employmentIncomes = [
  { label: 'W-2 Forms', value: 'w2Forms' },
];
export const investmentIncomes = [
  { label: '1099-DIV (Dividends).', value: '1099div' },
  { label: '1099-INT (Interest).', value: '1099int' },
  { label: '1099-B (Brokerage Statements).', value: '1099b' },
];

export const selfEmploymentIncomes = [
  { label: '1099-MISC or 1099-NEC Forms.', value: '1099MiscNecSelfEmploy' },
  { label: 'Business Income and Expense Statements.', value: 'inComeExpensesStatement' },
];

export const rentalIncomes = [
  { label: '1099-MISC or 1099-NEC Forms (if applicable).', value: '1099MiscNecRental' },
  { label: 'Rental Income and Expense Statements.', value: '1099incomeExpenses' },
];

export const retirementIncomes = [
  { label: '1099-R Forms.', value: '1099rForms' },
  { label: '1099-SSA Forms.', value: '1099SsaForms' },
];

export const salesAssets = [
  { label: 'At any time during 2022, did you or your spouse sell any property?', value: 'soldProperty' },
];